module.exports = __webpack_public_path__ + "img/ag_logo_1.a502427b.png";